/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Pharmacy Counselor API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";

export const PatchCounselingAIAssistantReceptionRequestBodyTypename =
  "PatchCounselingAIAssistantReceptionRequestBody" as const;

/**
 *
 * @export
 * @interface PatchCounselingAIAssistantReceptionRequestBody
 */
export interface PatchCounselingAIAssistantReceptionRequestBody {
  /**
   *
   * @type {string}
   * @memberof PatchCounselingAIAssistantReceptionRequestBody
   */
  resumeStatus?: PatchCounselingAIAssistantReceptionRequestBodyResumeStatusEnum;
  /**
   *
   * @type {Date}
   * @memberof PatchCounselingAIAssistantReceptionRequestBody
   */
  resumeTime?: string;
  /**
   * Resource type name
   * @type {string}
   * @memberof PatchCounselingAIAssistantReceptionRequestBody
   */
  readonly __typename?: string;
}

/**
 * @export
 * @enum {string}
 */
export enum PatchCounselingAIAssistantReceptionRequestBodyResumeStatusEnum {
  CameBackOnSameDay = "came_back_on_same_day",
  CameBackOnDifferentDay = "came_back_on_different_day",
  PrescriptionPreSubmitted = "prescription_pre_submitted",
  PickUpMissingMedicine = "pick_up_missing_medicine",
}

export function PatchCounselingAIAssistantReceptionRequestBodyFromJSON(
  json: any
): PatchCounselingAIAssistantReceptionRequestBody {
  return PatchCounselingAIAssistantReceptionRequestBodyFromJSONTyped(json, false);
}

export function PatchCounselingAIAssistantReceptionRequestBodyFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PatchCounselingAIAssistantReceptionRequestBody {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PatchCounselingAIAssistantReceptionRequestBodyTypename,

    resumeStatus: !exists(json, "resume_status") ? undefined : json["resume_status"],
    resumeTime:
      !exists(json, "resume_time") ||
      (typeof json["resume_time"] === "string" && json["resume_time"].substring(0, 4) === "0001")
        ? undefined
        : json["resume_time"],
  };
}

export function PatchCounselingAIAssistantReceptionRequestBodyToJSON(
  object?: PatchCounselingAIAssistantReceptionRequestBody | null
): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    resume_status: value.resumeStatus,
    resume_time: value.resumeTime === undefined ? undefined : tzDate(value.resumeTime).format(),
  };
}
